export interface IAgreementBaseTemplateForm {
  title: string;
  defaultValue: string;
}

export interface IAgreementBaseTemplate extends IAgreementBaseTemplateForm {
  position: number;
  update: boolean;
}

export interface IAgreementTemplatBaseResponse extends IAgreementBaseTemplate {}

export interface ITextAgreementTemplate extends IAgreementBaseTemplate {}
export interface ISelectAgreementTemplate extends IAgreementBaseTemplate {
  options: string[];
}

export interface ITextAgreementTemplateForm
  extends IAgreementBaseTemplateForm {}
export interface ISelectAgreementTemplateForm
  extends IAgreementBaseTemplateForm {
  options: string[];
}

export interface ITextAgreementTemplateResponse
  extends IAgreementTemplatBaseResponse {
  id: string;
}
export interface ISelectAgreementTemplateResponse
  extends IAgreementTemplatBaseResponse {
  id: string;
  options: string[];
}

export interface IAgreementTemplatetAggregator {
  textAgreementTemplate: ITextAgreementTemplate | null;
  selectAgreementTemplate: ISelectAgreementTemplate | null;
}

export interface IDistributionSharesForm {
  name: string;
  id: string;
  percent?: number;
}

export interface IAgreementTemplatetAggregatorForm {
  type: AGREEMENT_TYPE;
  textAgreementTemplate?: ITextAgreementTemplateForm | null;
  selectAgreementTemplate?: ISelectAgreementTemplateForm | null;
  distributionTemplateShares?: IDistributionSharesForm | null;
}

export interface IUpdateAgreementTemplate {
  agreementTemplateId: string;
  textAgreementTemplate: ITextAgreementTemplate | null;
  selectAgreementTemplate: ISelectAgreementTemplate | null;
}

export interface IUpdateAgreementTemplateResponse {
  agreementTemplaceId: string;
  position: number;
  title: string;
  agreementType: AGREEMENT_TYPE;
}

export type IAgreementTemplateResponse = {
  id: string;
  position: number;
  title: string;
  defaultValue: string;
} & (
  | { type: AGREEMENT_TYPE.text; options: null }
  | { type: AGREEMENT_TYPE.select; options: string[] }
);

export enum AGREEMENT_TYPE {
  unknown = -1,
  text = 1,
  select = 2,
  shares = 3,
  defaultShare = 4,
}
